// Emitted on the shared Emitter (utils/emitter.ts) by the report drawer each
// time a submit fails validation. The payload is antd's validateFields error.
export const REPORT_VALIDATION_FAILED = "reportValidationFailed";

// Emitted on the shared Emitter by the report drawer to open one item of a
// list, such as the finding picked on the audit page. FindingsList opens that
// finding; follow-up actions are always open, so nothing listens for them.
export const REPORT_REVEAL_ITEM = "reportRevealItem";

export type ReportRevealItemPayload = {
	listName: string;
	index: number;
};

// antd's Collapse open animation takes 200ms; the extra 100ms covers the
// render and the drawer's tab switch, so a field has its final position
// before it is scrolled to.
export const SCROLL_AFTER_OPEN_MS = 300;
